import { lazy } from 'react';

const CertifiedTransformerNomineesConsultPageConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}

	},
	routes: [
		{
			path: '/transformer/certificates/consult/nominees',
			component: lazy(() => import('./CertifiedNomineesPage'))
		}
	]
};

export default CertifiedTransformerNomineesConsultPageConfig;